<template>
    <div style="margin-top:10px;" v-show="results_count">
      <article :style="window.width < 480 ? 'font-size:10px; margin-bottom:10px;' : 'font-size:12px; margin-bottom:10px;'"  class="message is-danger">
        <div class="message-body">
          {{ $tc('sondage.reponse', results_count, { count: results_count }) }}
          <br />
          {{$t('sondage.razExplications')}}
          <router-link :to="{ name: 'Admin'}">{{$t('sondage.UrlListeSondages')}}</router-link>
        </div>
      </article>
    </div>
</template>

<script>
export default {
  props: ['window'],
  computed: {
    results_count: {
      get: function () {
        return this.$store.state.sondage.fields.results_count
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/question/components/PreviousResponseMessage.vue